import { useCallback, useState, useEffect, useLayoutEffect } from "react"
import useCookie from "react-use-cookie"
import useWindowDimensions from "@hooks/useWindowDimensions"
import useDelayedRender from "@hooks/useDelayedRender"
import useMountObserver from "@hooks/useMountObserver"
import { LAYOUT_BACKGROUND_COLOR } from "../../constants"

const useLayoutConfiguration = () => {
  const { isDelayed } = useDelayedRender();
  const { isMounted } = useMountObserver()
  const [showLinks, setShowLinks] = useState(false)
  const [userToken, setUserToken] = useCookie("impressit")
  const [headerTitle, setHeaderTitle] = useState()
  const [openMobileFilters, setOpenMobileFilters] = useState(false)
  const [isOpenMobileBlogFilters, setIsOpenMobileBlogFilters] = useState(false);
  const [selectedFilterOption, setSelectedFilterOption] = useState("");
  const [articleCategories, setArticleCategories] = useState([]);
  const { isMobile } = useWindowDimensions();

  const openMobileFiltersSection = () => setIsOpenMobileBlogFilters(true);
  const closeMobileFilters = () => setIsOpenMobileBlogFilters(false);

  useLayoutEffect(() => {
    document.documentElement.style.background = LAYOUT_BACKGROUND_COLOR;
  }, []);

  useEffect(() => {
    !isMobile && closeMobileFilters();
  }, [isMobile])

  const handleClick = useCallback((e) => {
      e.preventDefault()
      showLinks ? setTimeout(() => setShowLinks(false), 1000) : setShowLinks(true); 
    },[setShowLinks, showLinks])

  useEffect(() => {
    const { style } = document.getElementsByTagName("body")[0];
    style.overflowY = showLinks ? "hidden" : "scroll";
  }, [showLinks])

  useEffect(() => {
    window.gtag = function() { window.dataLayer?.push(arguments);};
    if (window.localStorage.getItem("impressit") === null) {
      window.gtag("consent", "default", {
        functionality_storage: "denied",
        security_storage: "denied",
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        analytics_storage: "denied",
        personalization_storage: "denied",
        wait_for_update: 500,
      })
    } else {
      window.gtag("consent", "default", JSON.parse(localStorage.getItem("impressit")))
    }
}, [])

  return {
    isDelayed,
    isMounted,
    openMobileFilters,
    articleCategories,
    isOpenMobileBlogFilters,
    showLinks,
    headerTitle,
    selectedFilterOption, 
    userToken,
    setSelectedFilterOption,
    setArticleCategories,
    setShowLinks,
    setOpenMobileFilters,
    setHeaderTitle,
    handleClick, 
    openMobileFiltersSection,
    setUserToken,
    closeMobileFilters,
  }
}

export default useLayoutConfiguration
